
import { computed, defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { brandIconFor } from '@/composables/billing/useBrandIcon';
import { PaymentMethodItem } from '@/types/billing-types';

export default defineComponent({
  name: 'SavedCardDisplay',

  props: {
    card: {
      type: Object as PropType<PaymentMethodItem | null>,
      default: null,
    },

    /** Whether to render the "default" pill in the corner. */
    showDefaultPill: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const brandIcon = computed(() => brandIconFor(props.card?.brand));

    return { t, brandIcon };
  },
});
